import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// takes optional prop: 'message', if provided, a short explanatory message displayed with spinner

const Spinner = props => {
  const message = props.message
    ? <div className="message">
      {props.message}
    </div>
    : null

  const specialClass = props.className || ''
  return (
    <div className={'window-loading ' + specialClass} id="spinner">
      <div className="wrapper">
        {message}
        <div className="spinner-wrapper">
          <FontAwesomeIcon
            icon={['fas', 'circle-notch']}
            spin
            size="3x"
            fixedWidth
          />
        </div>
      </div>
    </div>
  )
}

export default Spinner
